module.exports = __webpack_public_path__ + "img/partners_default.a6a32aaa.png";